/*
    Generated using Simple-Scaffold
    npx simple-scaffold@latest \
        -t templates/feature -o src/features RunDetails
*/

import React, { useEffect, useRef } from 'react';
import { useParams, Navigate, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import 'zone.js';

import { RankerAlgorithim, RankDirection, RankAlignment } from '@google/workflow-graph';
import '@google/workflow-graph/web-component/registerWorkflowGraphWebComponent.js';


import  styles from './RunDetails.module.css';

import { selectRunDetails, init as initAction } from './runDetailsSlice';

import { 
    Stack,
    Typography,
    Divider,
    Drawer,
    Modal,
    Box,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableHead,
    Select,
    MenuItem,
    Stepper,
    Step,
    StepLabel
} from '@mui/material';

import {
    Close as CloseIcon,
    Info as InfoIcon,
    PlayCircleOutline as PlayCircleOutlineIcon,
} from '@mui/icons-material';
import { infoColor } from '../../components/constants/Constants';

/** Default Node Vertical Spacing */
const NODE_VERTICAL_SPACING = 60;
/** Default Node Horizontal Spacing */
const NODE_HORIZONTAL_SPACING = 40;

const logger = { logEvent: (event) => { console.log(event) } };

/**
 * Common LayoutOptions for Dagre
 */
const DEFAULT_LAYOUT_OPTIONS = {
  rankDirection: RankDirection.TOP_TO_BOTTOM,
  rankAlignment: RankAlignment.NONE,
  ranker: RankerAlgorithim.NETWORK_SIMPLEX,
  edgeSeparation: 4,
  rankSeparation: NODE_VERTICAL_SPACING,
  nodeSeparation: NODE_HORIZONTAL_SPACING,
};

const fakeGraph = JSON.parse(
  `
  {"state":{"BQ":{"displayName":"BigQuery Fetcher","state":"SKIPPED","description":"ai_model_data","icon":{"text":"BQ","iconColors":"inverted"}},"Transforms":{"displayName":"Dataproc Transforms","state":"SUCCEEDED","description":"/api/fn_clean_data","icon":{"text":"HTTP","iconColors":"inverted"}},"Email":{"displayName":"Email (deleted)","description":"Email sent to management","icon":{"name":"web","iconset":"shell","size":"small"},"modifiers":["deleted"],"callout":"deleted"},"Text":{"description":"PagerDuty text","state":"NO_STATE_RUNTIME","icon":{"name":"topic","iconset":"shell","size":"small"}},"Text2":{"description":"PagerDuty text2","state":"NO_STATE_RUNTIME","icon":{"name":"topic","iconset":"shell","size":"small"}},"Broadcast Table":{"state":"SUCCEEDED","description":"Using a custom execution icon","subType":"process node","icon":{"name":"performance-dashboard","iconset":"shell","size":"small"}},"Extract Entities":{"state":"SKIPPED"},"Scan for Importance":{"state":"SKIPPED"},"Send via APIs":{"state":"PENDING","artifactRefs":[{"id":"Text Logs","path":["sub2"]},{"id":"Execution Logs","path":["sub2"]}],"callout":{"text":"This is a simple callout that goes on for way to long","bg":"#1a73e8","color":"white"}},"Big Query table":{"state":"CANCELLED"},"AutoML Tables":{"state":"FAILED"},"Output to BigQuery":{"state":"RUNNING"},"CreateFinal":{"conditionalQuery":"1 == 1","artifactRefs":[{"id":"BigTable","path":["sub1"]},{"id":"BigTable","path":["sub1","sub1"]}]},"CustomNode1":{"templateRef":"outlineBasic","width":480,"height":150,"includeInStepCount":false,"artifactRefs":[{"id":"BigTable","path":["sub1"]}]},"TransformedTable":{"state":"NO_STATE_RUNTIME"},"BigTable":{"state":"NO_STATE_RUNTIME","displayName":"Big Table Artifact","icon":{"name":"artifact-model","iconset":"cloud_ai","size":"large"}},"BigQueryTable":{"state":"NO_STATE_RUNTIME","icon":{"name":"artifact-datasets","iconset":"cloud_ai","size":"large","color":"#af5cf7"}},"Entities":{"state":"NO_STATE_RUNTIME","description":"People: 512, Places: 82, Indexes: 4012","icon":{"text":"ENT","iconColors":"inverted","color":"#52cee6"}},"TensorFlow Training":{"state":"TIMEOUT","description":"Defaulted to iteration-2","hasControlNode":true,"treatAsLoop":true,"selectedLoopId":"it-2","icon":{"name":"group-iterative","iconset":"cloud_ai","size":"medium"},"groupMeta":{"it-1":{"state":"SUCCEEDED","displayName":"Iteration 1","groupMeta":{"Trainer":{"state":"SUCCEEDED","description":"gcr.io/python-images/train-cvvv-v1.1","artifactRefs":[{"id":"BigTable","path":[]}]},"Intermediate-Model":{"state":"NO_STATE_RUNTIME","subType":"model","icon":{"name":"artifact-model","iconset":"cloud_ai","size":"large"}},"Test for accuracy":{"state":"SUCCEEDED","description":"Validates that accuracy is above 85%","conditionalQuery":"getModel(\\"Intermediate-Model\\").accuracy > .85"}}},"it-2":{"state":"SUCCEEDED","displayName":"Iteration 2","groupMeta":{"Trainer":{"state":"SUCCEEDED","description":"gcr.io/python-images/train-cvvv-v1.1","artifactRefs":[{"id":"BigTable","path":[]}]},"Intermediate-Model":{"state":"NO_STATE_RUNTIME","subType":"model","icon":{"name":"artifact-model","iconset":"cloud_ai","size":"large"}},"Test for accuracy":{"state":"SUCCEEDED","description":"Validates that accuracy is above 85%","conditionalQuery":"getModel(\\"Intermediate-Model\\").accuracy > .85"}}},"it-4":{"state":"SUCCEEDED","displayName":"Iteration 4","groupMeta":{"Trainer":{"state":"SUCCEEDED","description":"gcr.io/python-images/train-cvvv-v1.1","artifactRefs":[{"id":"BigTable","path":[]}]},"Intermediate-Model":{"state":"NO_STATE_RUNTIME","subType":"model","icon":{"name":"artifact-model","iconset":"cloud_ai","size":"large"}},"Test for accuracy":{"state":"SUCCEEDED","description":"Validates that accuracy is above 85%","conditionalQuery":"getModel(\\"Intermediate-Model\\").accuracy > .85"}}},"it-3":{"displayName":"Iteration 3","state":"SKIPPED","groupMeta":{"Trainer":{"state":"SKIPPED","description":"gcr.io/python-images/train-cvvv-v1.1","artifactRefs":[{"id":"BigTable","path":[]}]},"Intermediate-Model":{"state":"NO_STATE_RUNTIME","subType":"model","icon":{"name":"artifact-model","iconset":"cloud_ai","size":"large"}},"Test for accuracy":{"state":"NOT_TRIGGERED","description":"Validates that accuracy is above 85%","conditionalQuery":"getModel(\\"Intermediate-Model\\").accuracy > .85"}}},"it-5":{"displayName":"Iteration 5","state":"TIMEOUT","groupMeta":{"Trainer":{"state":"TIMEOUT","description":"gcr.io/python-images/train-cvvv-v1.1","artifactRefs":[{"id":"BigTable","path":[]}]},"Intermediate-Model":{"state":"NO_STATE_RUNTIME","subType":"model","icon":{"name":"artifact-model","iconset":"cloud_ai","size":"large"}},"Test for accuracy":{"state":"PENDING","description":"Validates that accuracy is above 85%","conditionalQuery":"getModel(\\"Intermediate-Model\\").accuracy > .85"}}}}},"sub1":{"state":"CANCELLED","hasControlNode":false,"displayName":"Subdag (sub1)","groupMeta":{"Fake Exec 1":{"state":"SUCCEEDED","conditionalQuery":"len(groupParam) == 1"},"BigTable":{"displayName":"Sub BigTable","state":"NO_STATE_RUNTIME","icon":{"name":"artifact-datasets","iconset":"cloud_ai","size":"large","color":"#af5cf7"}},"AutoML Tables":{"state":"NOT_TRIGGERED","conditionalQuery":"len(groupParam) > 2 && thisIsNotTest(ctx)"},"Output to BigQuery":{"state":"CANCELLING"},"sub1":{"state":"NOT_TRIGGERED","hasControlNode":true,"conditionalQuery":"isTaskDone(\\"outputToBigQuery\\")","displayName":"Nested Subdag (sub1)","artifactRefs":[{"id":"TransformedTable","path":[]}],"groupMeta":{"Fake Exec 1":{"artifactRefs":[{"id":"TransformedTable","path":[]}]},"BigTable":{"displayName":"Sub x2 BigTable","icon":{"name":"artifact-datasets","iconset":"cloud_ai","size":"large","color":"#af5cf7"}}}},"CustomNode2":{"templateRef":"embedYt","width":280,"height":37,"includeInStepCount":false}}},"sub2":{"state":"RUNNING","hasControlNode":true,"displayName":"Log Ingestion (sub2)","description":"A simple subdag that shows edge-snapping logic above it","groupMeta":{"Text Logs":{"state":"NO_STATE_RUNTIME","icon":{"name":"logs","iconset":"shell","size":"small"}},"Execution Logs":{"state":"NO_STATE_RUNTIME","icon":{"name":"logs","iconset":"shell","size":"small"}},"Scan Texts":{"state":"SUCCEEDED","artifactRefs":[{"id":"Text","path":[]},{"id":"Text2","path":[]}]},"Label Execution Logs":{"state":"RUNNING","artifactRefs":[{"id":"Text","path":[]},{"id":"Entities","path":[]}]}}}},"skeleton":[{"id":"BQ","type":"execution","next":[{"id":"Transforms","type":"execution","next":[{"id":"TransformedTable","type":"artifact","next":[{"id":"Big Query table","type":"execution","next":[{"id":"BigTable","type":"artifact","next":[{"edgeLabel":"storage (red-edge)","edgeOpts":{"toMarkerStyle":"arrow","color":"#E94235","weight":3},"id":"AutoML Tables","type":"execution","next":[{"edgeOpts":{"color":"#E94235","toMarkerStyle":"arrow"},"id":"Output to BigQuery","type":"execution","next":[{"edgeOpts":{"toMarkerStyle":"arrow"},"id":"BigQueryTable","type":"artifact","next":[{"edgeOpts":{"toMarkerStyle":"arrow"},"id":"CreateFinal","type":"execution"}]}]}]},{"edgeLabel":"input-data","id":"TensorFlow Training","type":"group","definition":[{"id":"it-1","type":"group","definition":[{"id":"Trainer","type":"execution","next":[{"id":"Intermediate-Model","type":"artifact","next":[{"id":"Test for accuracy","type":"execution"}]}]}]},{"id":"it-2","type":"group","definition":[{"id":"Trainer","type":"execution","next":[{"id":"Intermediate-Model","type":"artifact","next":[{"id":"Test for accuracy","type":"execution"}]}]}]},{"id":"it-3","type":"group","definition":[{"id":"Trainer","type":"execution","next":[{"id":"Intermediate-Model","type":"artifact","next":[{"id":"Test for accuracy","type":"execution"}]}]}]},{"id":"it-4","type":"group","definition":[{"id":"Trainer","type":"execution","next":[{"id":"Intermediate-Model","type":"artifact","next":[{"id":"Test for accuracy","type":"execution"}]}]}]},{"id":"it-5","type":"group","definition":[{"id":"Trainer","type":"execution","next":[{"id":"Intermediate-Model","type":"artifact","next":[{"id":"Test for accuracy","type":"execution"}]}]}]}],"next":[{"id":"Output to BigQuery","type":"execution"},{"edgeLabel":"SUB-DAG 1","id":"sub1","type":"group","definition":[{"id":"Output to BigQuery","type":"execution"},{"id":"Fake Exec 1","type":"execution","next":[{"id":"BigTable","type":"artifact","next":[{"edgeLabel":"storage","id":"AutoML Tables","type":"execution"},{"edgeLabel":"SUB-DAG Nested 1","id":"sub1","type":"group","definition":[{"id":"Output to BigQuery","type":"execution"},{"id":"Fake Exec 1","type":"execution","next":[{"edgeOpts":{"weight":10},"id":"BigTable","type":"artifact","next":[{"edgeLabel":"storage","id":"AutoML Tables","type":"execution"}]}]}],"next":[{"edgeLabel":"custom-video","id":"CustomNode2","type":"artifact"}]}]}]}],"next":[{"id":"CreateFinal","type":"execution"},{"id":"CustomNode1","type":"execution"}]}]}]}]},{"edgeOpts":{"toMarkerStyle":"arrow"},"id":"sub1","type":"group"},{"id":"Broadcast Table","type":"execution","next":[{"id":"Email","type":"artifact","next":[{"id":"Send via APIs","type":"execution"}]},{"id":"Text2","type":"artifact","next":[{"edgeLabel":"obtuse-edge","id":"sub2","type":"group"}]},{"id":"Text","type":"artifact","next":[{"edgeLabel":"SUB-DAG 2","id":"sub2","type":"group","definition":[{"id":"Scan Texts","type":"execution","next":[{"id":"Text Logs","type":"artifact"}]},{"id":"Label Execution Logs","type":"execution","next":[{"id":"Execution Logs","type":"artifact"}]}],"next":[{"id":"Send via APIs","type":"execution"}]}]},{"id":"Extract Entities","type":"execution","next":[{"id":"Scan for Importance","type":"execution","next":[{"id":"sub2","type":"group"}]},{"id":"Entities","type":"artifact","next":[{"id":"sub2","type":"group"}]}]}]}]}]}]}]}
  `
);

function getUniqueBy(arr, keys) {
    const uniqueObj = arr.reduce((unique, o) => {
        const key = keys.map((k) => o[k]).join('|');
        unique[key] = o;
        return unique;
    }, {});
    return Object.values(uniqueObj);
}

export function RunDetails(props) {
    const { org, integrationSlug, jobSlug } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { details, detailsFetchStatus } = useSelector(selectRunDetails);
    const firstFailedStep = useRef(null);

    const workflowJob = details?.jobDetails?.workflow_job;
    const egressReport = details?.egressReport;
    const allJobAttemptsIDMap = details?.allJobAttemptsIDMap;

    let queueTime = "N/A";
    let buildTime = "N/A";

    if (workflowJob) {
        const created = new Date(workflowJob.created_at);
        const started = new Date(workflowJob.started_at);
        const completed = new Date(workflowJob.completed_at);

        if (created && started) {
            queueTime = `${(started.getTime() - created.getTime())/1000}s`;
        }

        if (started && completed) {
            buildTime = `${(completed.getTime() - started.getTime())/1000}s`;
        }
    }

    const basePath = `/${org}/github/${integrationSlug}/actions`;

    const graphRef = React.useRef();


    useEffect(() => {
        const graphComponent = graphRef.current;

        const onSelectedNodeChange = (event) => {
            console.log(event);
        }


        if (graphComponent) {
            const props = {
                enableMinimap: false,
                enableToolbar: false,
                expandedMode: false,
                selectedNode: null,
                zoom: 0.6,
                loading: false,
                dagSpec: { skeleton: fakeGraph.skeleton, meta: fakeGraph.state },
                optimizeForOrm: false,
                followNode: null,
                layout: DEFAULT_LAYOUT_OPTIONS,
                hoveredEdge: undefined,
                logger: logger
            }

            Object.assign(graphComponent, props);
            graphComponent.addEventListener("selectedNodeChange", onSelectedNodeChange);
        }

        return () => {
            graphComponent?.removeEventListener("selectedNodeChange", onSelectedNodeChange);

        }
    }, [jobSlug])

    useEffect(() => {dispatch(initAction({integrationSlug, jobSlug}))}, [integrationSlug, jobSlug]);

    return (
        <Box
            sx={{width: '100%', position: 'fixed', top: 0, left: 0, height: '100vh', zIndex: 1000}}
            SlideProps={{direction: "left"}}
        >
            <Stack direction="row" sx={{width: '100%'}}>
                <Box style={{width: 'calc(100% - 600px)', backgroundColor: 'rgba(0, 0, 0, 0.5)'}} 
                    onClick={() => navigate(basePath)}>
                </Box>
                <Stack direction="column" className={styles.container}>
                    {
                        workflowJob &&
                        <Stack direction="column"  className={styles.header}>
                            <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
                                <Stack direction="row" alignItems="center">
                                    <PlayCircleOutlineIcon />
                                    <Typography sx={{ml: 1, width: '350px'}} variant="h6" noWrap>
                                        {workflowJob.workflow_name} - {workflowJob.name}
                                    </Typography>
                                </Stack>
                                <Stack direction="row" alignItems="center" sx={{translate: "0 6px"}}>
                                {
                                        <Select variant="standard"
                                            value={jobSlug}
                                            size="small"   
                                            onChange={(e) => navigate(`/${org}/github/${integrationSlug}/actions/run-details/${e.target.value}`)}
                                            sx={{
                                                "&:before": {
                                                    borderBottom: 0
                                                },
                                                "&:hover:before": {
                                                    borderBottom: "0!important"
                                                },
                                                "&:hover:after": {
                                                    borderBottom: "0!important"
                                                },
                                                "&:after": {
                                                    borderBottom: 0
                                                },
                                                "&:hover": {
                                                    borderBottom: 0
                                                },
                                            }}
                                        >
                                            {
                                                Object.keys(allJobAttemptsIDMap).sort((a,b) => b-a).map((attempt, index) => {
                                                    return (
                                                        <MenuItem key={`attempt-${index}`} value={allJobAttemptsIDMap[attempt]}>
                                                            Run Attempt :: {attempt}
                                                        </MenuItem>
                                                    )
                                                })
                                            }
                                      </Select>
                                    }
                                    <CloseIcon sx={{cursor: "pointer"}}
                                        onClick={() => navigate(basePath)} />
                                </Stack>
                            </Stack>
                            <Divider sx={{mb: 1}} />
                            {
                                workflowJob && 
                                <Table size="small" sx={{my: 2}}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell >
                                                <Typography >
                                                    Status
                                                </Typography>
                                            </TableCell>
                                            <TableCell >
                                                <Typography >
                                                    {workflowJob.status}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                                <Typography >
                                                    Conclusion
                                                </Typography>
                                            </TableCell>
                                            <TableCell >
                                                <Typography >
                                                    {workflowJob.conclusion}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                                <Typography >
                                                    Created
                                                </Typography>
                                            </TableCell>
                                            <TableCell >
                                                <Typography >
                                                    {workflowJob.created_at}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                                <Typography >
                                                    Started
                                                </Typography>
                                            </TableCell>
                                            <TableCell >
                                                <Typography >
                                                    {workflowJob.started_at}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                                <Typography >
                                                    Completed
                                                </Typography>
                                            </TableCell>
                                            <TableCell >
                                                <Typography >
                                                    {workflowJob.completed_at}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                                <Typography >
                                                    Queue Time
                                                </Typography>
                                            </TableCell>
                                            <TableCell >
                                                <Typography >
                                                    {queueTime}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                                <Typography >
                                                    Build Time
                                                </Typography>
                                            </TableCell>
                                            <TableCell >
                                                <Typography >
                                                    {buildTime}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            }
                            {
                                egressReport && egressReport.length > 0 &&
                                <React.Fragment>
                                    <Typography variant="body1" sx={{textTransform: 'uppercase'}}>
                                        Egress Report
                                    </Typography>
                                    <Divider sx={{mb: 1}} />
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell >
                                                    <Typography >
                                                        Domain
                                                    </Typography>
                                                </TableCell>
                                                <TableCell >
                                                    <Typography >
                                                        Scheme
                                                    </Typography>
                                                </TableCell>
                                                <TableCell >
                                                    <Typography >
                                                        Rule Name
                                                    </Typography>
                                                </TableCell>
                                                <TableCell >
                                                    <Typography >
                                                        Action
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                getUniqueBy(egressReport, ['domain', 'scheme']).map((report, index) => (
                                                    <TableRow key={`egress-report-table-${index}`}>
                                                        <TableCell >
                                                            <Typography >
                                                                {report.domain}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell >
                                                            <Typography >
                                                                {report.scheme}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell >
                                                            <Typography >
                                                                {report.rule_name}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell >
                                                            <Typography >
                                                                {report.action}
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>
                                    </Table>
                                </React.Fragment>
                            }
                            {
                                workflowJob && workflowJob.steps && workflowJob.steps.length > 0 &&
                                <React.Fragment>
                                    <Typography variant="body1" sx={{textTransform: 'uppercase'}}>
                                        Job Run Details
                                    </Typography>
                                    <Divider sx={{mb: 1}} />   
                                    
                                    <Stepper alternativeLabel sx={{maxWidth: '100%', padding: '10px', overflow: 'auto'}}>
                                        {
                                            workflowJob.steps.map((step, index) => {
                                                const failed = step.conclusion === 'failure';
                                                const labelProps = {
                                                    sx: {
                                                        minWidth: '100px',
                                                    }
                                                };
                                                let refProps = {};
                                                if (failed) {
                                                    labelProps.error = true;
                                                    refProps = {ref: firstFailedStep};
                                                }
                                                setTimeout(() => {
                                                    if (firstFailedStep.current) {
                                                        firstFailedStep.current.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
                                                    }
                                                }, 0);

                                                return (
                                                    <Step {...refProps} active={!failed} key={`${step.number}`}>
                                                        <StepLabel {...labelProps}>{step.name}</StepLabel>
                                                    </Step>
                                                );
                                            })
                                        }
                                    </Stepper>
                                </React.Fragment>
                            } 

                            <Typography variant="body1" sx={{textTransform: 'uppercase'}}>
                                Workflow graph
                            </Typography>
                            <Divider sx={{mb: 1}} />    
                            {
                                workflowJob  && workflowJob.steps && workflowJob.steps.length > 0 &&
                                <google-workflow-graph ref={graphRef}></google-workflow-graph>
                            }
                            {
                                (!workflowJob  || !workflowJob.steps || workflowJob.steps.length == 0)
                                && 
                                <Stack direction="column"  sx={{mt: 1}}>
                                    <Stack direction="column" alignItems="center" 
                                        sx={{borderRadius: 1, bgcolor: 'rgb(240 248 255)', p: 1 }}>
                                        <InfoIcon sx={{ fontSize: 24, color: infoColor }} />
                                        <Typography variant="body2" 
                                            sx={{mt: 1, textAlign: 'center', px: 3, color: 'rgb(1, 67, 97)'}}>
                                            You don't have any third party actions in this Github repository.
                                        </Typography>
                                    </Stack>
                                </Stack>
                            }
                        </Stack>
                    }
                </Stack>
            </Stack>
        </Box>
    )
}
